<template>
<ItpFormSelect2
  :name="path"
  v-model="item[path]"
  :dataSource="b_7315092382398562_dataSource"
  prefetch
  valueField="id"
  textField="name"
  bind-object
  :multiple="multiple"
  :clearable="clearable"
  :autofocus="autofocus"
  :disabled="readonly || item.isReadonly"
  :readonly="readonly || item.isReadonly"
  :required="required"
  optionTemplate="<UcSuggestContractOption :option=option></UcSuggestContractOption>"
  use-option-template-for-selected-option
  v-if="item"
  @optionSelected="evh_7315092382398562_optionSelected($event, {})"
>
</ItpFormSelect2>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcContractSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    required: true,
    type: String,
  })
  path!: string;

  @Watch('path')
  onPath(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("path")
  }

  @Prop({
    type: Object,
  })
  parameters!: object;

  @Watch('parameters')
  onParameters(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parameters")
  }

  @Prop({
    type: Boolean,
  })
  required!: boolean;

  @Watch('required')
  onRequired(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("required")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  @Prop({
    type: Boolean,
  })
  autofocus!: boolean;

  @Watch('autofocus')
  onAutofocus(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("autofocus")
  }

  @Prop({
    type: Boolean,
  })
  clearable!: boolean;

  @Watch('clearable')
  onClearable(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("clearable")
  }

  @Prop({
    type: Boolean,
  })
  multiple!: boolean;

  @Watch('multiple')
  onMultiple(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("multiple")
  }

  ux!: any;
  b_7315092382398562_dataSource!: any;

  async $$load_b_7315092382398562_dataSource() {
    return {
      name: "suggest_contract",
      parameters: this.parameters,
    }
  }

  dataMembers = ['ux', 'b_7315092382398562_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
        b_7315092382398562_dataSource: null,
      },
    }
  }

  async act_7315092382398562_emit_6988_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7315092382398562_emit_6988, alias=undefined
    return {
      event: "optionSelected",
      value: $event.option,
    }
  }

  async evh_7315092382398562_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_optionSelected.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_emit_6988: actions.EmitAction;
    evh_7315092382398562_optionSelected_6987: actions.EventHandlerImpl;
    evh_7315092382398562_optionSelected: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_emit_6988 = new actions.EmitAction(
      {
        actionArgs: this.act_7315092382398562_emit_6988_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_optionSelected_6987 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_emit_6988,
        event: "optionSelected",
        displayName: "emit",
      }
    );
    const evh_7315092382398562_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_optionSelected_6987],
      }
    );
    return {
      act_7315092382398562_emit_6988,
      evh_7315092382398562_optionSelected_6987,
      evh_7315092382398562_optionSelected,
    }
  }
}

Vue.component("UcContractSelector", UcContractSelector);

</script>